<template>
  <div class="form">
    <main>
      <div class="title">值班日志</div>
          <div v-show="username" class="username">值班人：{{ username }}</div>
    <el-form
      ref="formdata"
      label-width="80px"
      label-position="left"
      class="form1"
    >
      <el-form-item label="值班日期" prop="summary">
        <el-select v-model="infoid" placeholder="请选择" @change="daychange">
          <el-option
            v-for="item in dataes"
            :key="item.id"
            :label="item.beginTime | dayfilter"
            :value="item.id"
          >
            <span style="float: left">{{ item.beginTime | dayfilter }}</span>
            <span style="float: right">{{ item.createType | createTypeFilter }}</span>
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      label-position="left"
      class="form2"
      :rules="rules"
      v-show="havescheduling"
    >
      <el-form-item label="值班类型" prop="summary">
        <el-input
          v-model="form.createType"
          placeholder="值班标题"
          clearable
          :disabled="true"
        />
      </el-form-item>

      <el-form-item label="标题" prop="summary">
        <el-input
          v-model="form.summary"
          placeholder="值班标题"
          clearable
          :disabled="true"
        />
      </el-form-item>

      <el-form-item v-show="location" label="地址" prop="location">
        <el-input
          v-model="form.location"
          placeholder="请输入地址"
          clearable
          :disabled="true"
        />
      </el-form-item>
      <el-form-item label="日志" prop="description">
        <el-input
          v-model="form.description"
          placeholder="请输入值班日志"
          clearable
          :rows="5"
          type="textarea"
          :disabled="waitlocal"
        />
      </el-form-item>
      <div class="buttongroup">
        <el-button
          type="primary"
          @click="onSubmit"
          :disabled="waitlocal"
          :loading="buttonloading"
          >提交</el-button
        >
        <el-button
         @click="onCancel"
        >取消</el-button>
      </div>
    </el-form>
    </main>

  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import {
  updateJournal,
  GetAddressListAsync,
  getapiticket,
  GetUserInRuleList,
} from "@/api/Scheduling/Scheduling";
import * as moment from "moment";
import { Loading } from "element-ui";
import * as dd from "dingtalk-jsapi";
const Amap = window.AMap;
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name:'scheduling',
  data() {
    return {
      date: new Date(),
      createmodule: false,
      havescheduling: false,
      form: {
        summary: "", //标题
        name: "", //名称，
        jobnumber: "", //工号
        description: "", //日志
        location: "", //地址id
      },
      rules: {
        description: [
          { required: true, message: "请输入日志", trigger: "blur" },
        ],
      },
      fullscreenloading: "",
      id: "",
      waitlocal: true,
      lat: "",
      lng: "",
      addresses: [],
      username: "",
      location: "",
      loginasp: "https://zb.wmu.edu.cn/scheduling", // "http://172.18.238.1'
      dingding: "https://appdev.wmu.edu.cn/scheduling",
      userAddress: "",
      buttonloading: false, //按钮加载
      buttontext: "更新",
      dataes: [],
      infoid: "",
    };
  },
  methods: {
    goback(){
      this.$router.back();
    },
    /**
     *
     */
    async getlocationAddress() {
      this.addresses = await GetAddressListAsync({ BelongId: this.location });
    },
    /**
     * select 选择后
     * @param {*} item
     */
    async daychange(item) {
      const result = this.dataes.find((t) => t.id == item);
      this.form = {
        summary: result.summary, //标题
        name: result.userName, //名称，
        jobnumber: result.jobNo, //工号
        description: result.description, //日志
        location: result.location, //地址id
        createType: result.createType === 1 ? "领导值班" 
        : result.createType === 4 ? "辅导员值班"
        : result.createType === 5 ? "保卫处值班" : ""
      };
      this.havescheduling = true;
      this.id = item;
      if (result.location) {
        this.waitlocal = true;
        this.location = this.form.location;
        await this.getlocationAddress();
        //如果有地址定位
        await this.dingdingLocalget();
      } else {
        this.waitlocal = false;
        this.location = false;
      }
    },
    /**
     * 按钮加载
     * @param {*} _bool
     */
    buttonloadingfun(_bool) {
      if (_bool) {
        this.buttonloading = true;
        this.buttontext = "更新中";
      } else {
        this.buttonloading = false;
        this.buttontext = "更新";
      }
    },
    judgeInCircle() {
      const lnglats = this.addresses.map((t) => {
        const arr = [];
        arr.push(t.lng);
        arr.push(t.lat);
        return arr;
      });
      var p0 = [this.lng, this.lat];
      if (Amap.GeometryUtil.isPointInRing(p0, lnglats)) {
        //在里面
        this.location = false;
      } else {
        //不在里面
        this.$message({
          message: `定位信息：您当前所在位置${this.userAddress}不在签到位置内`,
          type: "warning",
          customClass: "myBox",
        });
      }
    },
    async getapiticket() {
      await getapiticket({
        url: window.location.href,
      }).then((res) => {
        dd.config({
          agentId: res.agentId, // 必填，微应用ID
          corpId: res.corpId, //必填，企业ID
          timeStamp: res.timeStamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，自定义固定字符串。
          signature: res.signature, // 必填，签名
          type: 0, //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
          jsApiList: ["device.geolocation.get"], // 必填，需要使用的jsapi列表，注意：不要带dd。
        });
        dd.error(function (err) {
          alert(" dd error: " + JSON.stringify(err));
        }); //
      });
    },

    /**
     * 钉钉定位获得
     */
    async dingdingLocalget() {
      let loadingInstance = Loading.service({
        text: "正在获取钉钉位置",
      });
      await this.getapiticket();
      var _that = this;
      try {
        dd.ready(function () {
          dd.device.geolocation.get({
            targetAccuracy: 20,
            coordinate: 1,
            onSuccess: function (result) {
              _that.$nextTick(() => {
                loadingInstance.close();
              });
              _that.lng = result.longitude;
              _that.lat = result.latitude;
              _that.userAddress = result.address;
              _that.judgeInCircle();
            },
            onFail: function (err) {
              _that.$nextTick(() => {
                loadingInstance.close();
              });
              _that.$message({
                message: `钉钉定位错误：${JSON.stringify(err)}`,
                type: "error",
                customClass: "myBox",
              });
            },
          });
        });
        dd.error((error) => {
          _that.$nextTick(() => {
            loadingInstance.close();
          });
          _that.$message({
            message: `钉钉错误：${JSON.stringify(error)}`,
            type: "error",
            customClass: "myBox",
          });
        });
      } catch (ex) {
        alert(JSON.stringify(ex));
        this.$message({
          message: `钉钉错误：${JSON.stringify(ex)}`,
          type: "error",
          customClass: "myBox",
        });
      }
    },
    /** */
    getinfo() {
      let loadingInstance = Loading.service({
        text: "正在读取值班数据",
      });
      GetUserInRuleList().then((res) => {
        if (res.length > 0) {
          this.dataes = res;
          this.infoid = this.dataes[0].id;
          this.daychange( this.infoid);
        } else {
          this.$message({
            message: "您近期没有值班信息",
            type: "warning",
            customClass: "myBox",
          });
        }
        loadingInstance.close();
      });
    },
    ///修改日志
    onSubmit() {
      this.$nextTick(() => {
        this.$refs["form"].validate((valid) => {
          console.log(valid, "valid");
          if (valid) {
            this.buttonloadingfun(true);
            updateJournal(this.form.description, this.id).then((res) => {
              console.log(res, "$$$");
              this.buttonloadingfun(false);
              this.$message({
                message: "日志提交成功",
                type: "success",
                customClass: "myBox",
              });
              this.$router.push({path:'/newcalendar',replace:true});
              //this.getinfo();
            });
          }
        });
      });
    },
    /**
     * 重置
     */
    onCancel(){
      this.form.description = '';
    },
    /**
     * 获取url数据
     * @param {*} name
     */
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    /**
     * 到中心验证页面
     */
    AuthorByOhter() {
      var loginServer = "http://authserver.wmu.edu.cn/authserver/login";
      var url1 = loginServer + "?service=" + encodeURIComponent(this.loginasp);
      window.location.href = url1;
    },
  },
  async mounted(){
    await this.$store.dispatch("app/setActive", 3);
  },
  async created() { 
   
    await this.$store.dispatch("app/setActive", 3);
    this.username = this.$store.getters.name;
    this.getinfo();
    
  },
  filters: {
    dayfilter: function (value) {
      console.log(value, "###");
      return moment(value).format("YYYY-MM-DD");
    },
    createTypeFilter:function(value){
      switch (value) {
        case 1:
          return "领导值班";
        case 4:
          return "辅导员值班";
        case 5:
          return "保卫部值班";
        default:
          return "未知";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-family: "楷体";
  letter-spacing: 3px;
}
.form {
  width: 100%;
  height: 100vh;
  max-width: 1000px;
  margin: auto;
}

header {
  img {
    width: 60%;
    max-width: 300px;
    margin-top: 1rem;
    margin-left: 1rem;
  }
  margin-bottom: 3vh;
}
.form1 {
  padding: 0rem 1rem;
}
.form2 {
  padding: 0rem 1rem 1rem 1rem;
}

.el-date-editor.el-input {
  width: 100%;
}
.buttongroup {
  margin: auto;
  text-align: center;
}
.el-form-item {
  margin-bottom: 1rem;
}
.username {
  text-align: right;
  margin: 0.5rem 1rem;
  font-size: 0.8rem;
}
.el-select {
  width: 100%;
}
</style>
<style>
.myBox {
  min-width: 80% !important;
}
main{
  margin-top:8vh;
}
</style>